export default __webpack_public_path__ + "static/media/vire25.3ed477c2.jpg";